import { render, staticRenderFns } from "./newContractTemplate.pug?vue&type=template&id=193e2bee&lang=pug&"
import script from "./newContractTemplate.ts?vue&type=script&lang=ts&"
export * from "./newContractTemplate.ts?vue&type=script&lang=ts&"
import style0 from "./newContractTemplate.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports